export default function ErrorPage() {
 const errorText = 'Unexpected error';
 //  const error = useRouteError();
 //  console.error(error);
 //  const isObj = error instanceof Object;
 //  if (isObj) {
 //   if ('statusText' in error && error.statusText === 'string') {
 //    errorText = error.statusText;
 //   } else if ('message' in error && error.message === 'string') {
 //    errorText = error.message;
 //   }
 //  }

 return (
  <div id="error-page">
   <h1>Oops!</h1>
   <p>Sorry, an unexpected error has occurred.</p>
   <p>
    <i>{errorText}</i>
   </p>
  </div>
 );
}
